export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-emerald-100 rounded-full mb-6">
              <i className="ri-information-line text-emerald-600"></i>
              <span className="text-emerald-700 text-sm font-semibold">About Us</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Committed to Your Digital Freedom
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              At MADERERA DON RAUL S.R.L., we believe that online privacy is a fundamental right. Our mission is to provide cutting-edge VPN technology that empowers individuals and businesses to browse the internet securely and freely.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              With our headquarters in Goya, Argentina, we serve users worldwide with a commitment to transparency, security, and exceptional service. Our VPN solution is built on the latest encryption standards and maintained by a team of cybersecurity experts dedicated to protecting your digital life.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-gray-50 rounded-lg p-6">
                <i className="ri-shield-check-line text-emerald-600 text-3xl mb-3"></i>
                <h4 className="text-gray-900 font-bold text-lg mb-2">Trusted Security</h4>
                <p className="text-gray-600 text-sm">Industry-leading encryption protocols</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-6">
                <i className="ri-team-line text-emerald-600 text-3xl mb-3"></i>
                <h4 className="text-gray-900 font-bold text-lg mb-2">Expert Team</h4>
                <p className="text-gray-600 text-sm">Dedicated cybersecurity professionals</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/b05079784f32c90840d3b02bcc839a49.jpg"
                alt="About MADERERA DON RAUL"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-emerald-500 rounded-full opacity-20 blur-3xl"></div>
            <div className="absolute -top-8 -right-8 w-40 h-40 bg-teal-500 rounded-full opacity-20 blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
